import PropTypes from 'prop-types';
import { useEffect } from 'react';

const SCROLL_TO_ERROR_DELAY_MS = 300; // let a just-switched / still-loading tab render before retrying

// Fields mark themselves with data-field-error when they have a touched error (see field components).
// The first match in DOM order is the visually-topmost error; we scroll the real element
// (firstElementChild of the display:contents marker wrapper) into the center.
const scrollToFirstError = containerRef => {
    const marker = containerRef.current?.querySelector('[data-field-error]');
    const target = marker?.firstElementChild ?? marker;
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
};

// Renders nothing; scrolls the first errored field into view whenever `trigger` changes.
const ScrollToFieldError = ({ containerRef, trigger }) => {
    useEffect(() => {
        if (!trigger) return undefined;
        // Try once after the render commits; if the errored field isn't in the DOM yet (a just
        // switched / still-loading tab), retry once after a short delay to let it settle.
        if (scrollToFirstError(containerRef)) return undefined;
        const timer = setTimeout(() => scrollToFirstError(containerRef), SCROLL_TO_ERROR_DELAY_MS);
        return () => clearTimeout(timer);
    }, [trigger]); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};

ScrollToFieldError.propTypes = {
    containerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    trigger: PropTypes.number,
};

export default ScrollToFieldError;
